import React, {Component} from 'react';


export default class extends Component {
    render() {
        return (
            <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
                <div className="container">
                    <a className="navbar-brand" href="index.html"><i className="fa fa-tencent-weibo"/> Moshel</a>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                            data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                            aria-label="Toggle navigation">
                        导航 <i className="fa fa-bars"/>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="https://hzy.pw/p/2554" target="_blank" rel="noopener noreferrer">关于本站</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://hzy.pw/connect" target="_blank" rel="noopener noreferrer">关于我</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="http://t.qq.com/hzy1996" target="_blank" rel="noopener noreferrer">腾讯微博原站</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://hzy.pw" target="_blank" rel="noopener noreferrer">我的个人博客</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
}



// WEBPACK FOOTER //
// ./src/head-and-foot/Navigation.js